export const educationData = [
    {
        id: 1,
        institution: 'The Oxford College of Engineering',
        course: 'Btech(CSE)',
        startYear: '2019',
        endYear: '2023'
    },
    {
        id: 2,
        institution: 'Jspider',
        course: 'Full Stack Developer',
        startYear: '2023',
        endYear: '2024'
    },
    // {
    //     id: 3,
    //     institution: 'Chhatrapati Shivaji Saraswati Vidyamandir Bulandshahr UP',
    //     course: 'Intermediate',
    //     startYear: '2016',
    //     endYear: '2018'
    // },
]